import { useI18n } from '@/lib/i18n'
import { useSectionHeading } from '@/lib/primarySection'
import EmailForm from '@/components/ui/EmailForm/EmailForm'
import MapEmbed from '@/components/ui/MapEmbed/MapEmbed'
import company from '@/content/company.json'
import { CONTACT_FORM_ENABLED } from '@/lib/features'
import './ContactSection.css'

type Content = { eyebrow: string; title: string; lede: string; direct: string; directOnly: string }

export default function ContactSection() {
  const { section, t, lang } = useI18n()
  const c = section('contact') as unknown as Content
  const whatsappNumber = company.whatsapp.replace('https://wa.me/', '+')

  const { Tag: Title, className: titleClass } = useSectionHeading('contact', 'h2')

  return (
    <section className="section" aria-labelledby="contact-title">
      <div className="section-head">
        <div>
          <span className="eyebrow">{c.eyebrow}</span>
          <Title id="contact-title" className={titleClass} style={{ marginTop: 12 }}>
            {c.title}
          </Title>
        </div>
        <p className="lede">{c.lede}</p>
      </div>

      <div className={`contact ${CONTACT_FORM_ENABLED ? '' : 'contact--direct'}`}>
        {CONTACT_FORM_ENABLED && (
          <div className="contact__form">
            <EmailForm />
          </div>
        )}

        <aside className="contact__aside">
          <span className="eyebrow eyebrow--plain">{CONTACT_FORM_ENABLED ? c.direct : c.directOnly}</span>
          <dl className="contact__details">
            <div>
              <dt>{t('nav.email')}</dt>
              <dd>
                <a href={`mailto:${company.mail}`}>{company.mail}</a>
              </dd>
            </div>
            <div>
              <dt>WhatsApp</dt>
              <dd>
                <a href={company.whatsapp} target="_blank" rel="noopener noreferrer" className="wa-text">
                  {whatsappNumber}
                </a>
              </dd>
            </div>
            <div>
              <dt>{t('nav.address')}</dt>
              <dd>{company.address}</dd>
            </div>
            <div>
              <dt>{t('nav.visitingHours')}</dt>
              <dd>{company.visiting_hours[lang]}</dd>
            </div>
          </dl>
          <div className="contact__map">
            <MapEmbed />
          </div>
        </aside>
      </div>
    </section>
  )
}
